<script setup lang="ts">
// 设置页面TDK参数
useHead({
  title: '房产超市',
  meta: [
    { name: 'keywords', content: '' },
    { name: 'description', content: '' },
  ],
})
</script>

<template>
  <NuxtPage />
</template>

<style scoped lang="scss">

</style>
